/* Shopify's current host forwards refreshTheme() to its chat frame. No access to
   shadow DOM, iframe documents, customer messages, or private transport APIs. */
(() => {
  const root = document.documentElement;
  let host;
  let frame;
  let disabled = false;
  const refresh = () => {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => {
      if (!host || disabled) return;
      if (typeof host.refreshTheme !== 'function') {
        host.removeAttribute('data-nda-brand-adapter');
        return;
      }
      try {
        if (!host.hasAttribute('data-nda-brand-adapter')) host.setAttribute('data-nda-brand-adapter', '');
        host.refreshTheme();
      } catch {
        // Retain the complete native widget if its integration contract changes.
        disabled = true;
        host.removeAttribute('data-nda-brand-adapter');
      }
    });
  };
  const connect = () => {
    host = document.querySelector('shopify-chat');
    if (!host) return false;
    customElements.whenDefined('shopify-chat').then(() => {
      refresh();
      new MutationObserver((records) => {
        if (records.some((record) => record.oldValue !== host.getAttribute(record.attributeName))) refresh();
      }).observe(host, {
        attributes: true, attributeOldValue: true, attributeFilter: ['open', 'shell-ready']
      });
    });
    return true;
  };
  const start = () => {
    if (!connect()) {
      const mountObserver = new MutationObserver(() => {
        if (connect()) mountObserver.disconnect();
      });
      mountObserver.observe(document.body, { childList: true });
    }
    new MutationObserver(refresh).observe(root, {
      attributes: true, attributeFilter: ['data-brand', 'data-theme-scheme']
    });
    window.addEventListener('pageshow', refresh);
    document.fonts?.ready.then(refresh);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
